<template>
  <div class="page-contact">

    <header-prop class="header-prop-contact" title="Hello" subtitle="how can we be of assistance?">
      <a href="https://www.facebook.com/noctorus.studio" target="_blank">
        <i class="fa fa-facebook"></i>
      </a>
      <a href="https://www.twitter.com/noctorus" target="_blank">
        <i class="fa fa-twitter"></i>
      </a>
      <a href="https://www.medium.com/@noctorus" target="_blank">
        <i class="fa fa-medium"></i>
      </a>
    </header-prop>

    <!-- <div class="section-contact-header container" style="background-color:gray;margin:5em auto;">

      <div class="columns is-gapless is-flex-mobile is-centered">
        <div class="column is-6 is-11-mobile has-text-centered">

          <div class="cont-desc" data-aos="fade-up" data-aos-once="true">
            <h1 class="supertitle">hello,</h1>
            <h2>What can we help you with?</h2>
          </div>

          <div class="cont-desc" data-aos="fade-up" data-aos-once="true">
            <a href="https://www.facebook.com/noctorus.studio" target="_blank">
              <i class="fa fa-facebook"></i>
            </a>
            <a href="https://www.twitter.com/noctorus" target="_blank">
              <i class="fa fa-twitter"></i>
            </a>
            <a href="https://www.medium.com/@noctorus" target="_blank">
              <i class="fa fa-medium"></i>
            </a>
          </div>

        </div>
      </div>
    </div> -->

    <contact-section id="section-contact"></contact-section>

    <section-comment v-if="false"></section-comment>

  </div>
</template>

<script>
import HeaderProp from '@/components/HeaderProp'
import ContactSection from '@/components/ContactSection'

export default {
  name: 'contact',
  metaInfo: {
    title: 'contact'
  },
  components: {
    HeaderProp,
    ContactSection
  },
  data () {
    return {
      scrollPos: 0
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.header-prop-contact {
  .fa {
    font-size: 3em;
    padding: 5px 15px;
  }
}

</style>



// WEBPACK FOOTER //
// Contact.vue?117c5762